module.exports = __webpack_public_path__ + "static/media/class_job_036.d720b97f.svg";